import { Chip, ControlListProps, useTranslation, useTranslations } from "@bsm/component";
import { useUserStudentFamilyCreateEmailForm } from "./useUserStudentFamilyCreateEmailForm";
import { useUserStudentFamilyMemberForm } from "./useUserStudentFamilyMemberForm";
import { UserStudentItem } from "../../details/components/UserStudentItem";

export const useUserStudentFamilyCreateForm = (id?: number): ControlListProps => {
    const [
        SAVE,
        CANCEL,
        DESIGNATION,
        FATHER_NAME,
        MOTHER_NAME,
        PAYMENT_PERIOD,
        PREFERED_PAYMENT_CURRENCY,
        PAYMENT_TYPE,
        EMAILS,
        COMMENTS,
        MEMBERS,
        CURRENCY
    ] = useTranslations(i18n);

    const emailForm = useUserStudentFamilyCreateEmailForm()
    const membersForm = useUserStudentFamilyMemberForm()
    const t = useTranslation()

    return {
        data: {
            forms: [
                {
                    type: "hidden",
                    name: "id",
                },
                {
                    type: "text",
                    name: "designation",
                    label: DESIGNATION,
                    required: true
                },
                {
                    type: "text",
                    name: "fatherName",
                    label: FATHER_NAME,
                },
                {
                    type: "text",
                    name: "motherName",
                    label: MOTHER_NAME,
                },
                {
                    type: "checkbox",
                    name: "paymentPeriod",
                    label: PAYMENT_PERIOD,
                    options: ['ANNUALLY', 'HALF_YEARLY', 'QUATERLY', 'BIMONTHLY', 'MONTHLY'].map(item => ({
                        label: t(`Bsm.Invoice.User.Student.Family.PaymentPeriod.${item}.Label`),
                        value: item
                    }))
                },
                {
                    type: "checkbox",
                    name: "paymentType",
                    label: PAYMENT_TYPE,
                    multiple: true,
                    options: ['BANK_TRANSFERT', 'CASH', 'CHEQUE'].map(item => ({
                        label: t(`Bsm.Invoice.User.Student.Family.PaymentType.${item}.Label`),
                        value: item
                    }))
                },
                {
                    type: 'de-select',
                    name: 'currencies',
                    tp: 'CURRENCY',
                    multiple: true,
                    className: '',
                    label: CURRENCY,
                },

                {
                    buttons: [{
                        label: 'std_edit',
                        icon: 'fa fa-pen',
                        className: 'btn btn-default',
                        is_edit_btn: true
                    }],
                    is_editable: true,
                    multiple: true,
                    controlList: emailForm,
                    type: 'substep',
                    name: 'emails',
                    label: EMAILS,
                    value: [],
                    onRenderTemplate: (value) => {
                        const mail = value.to ? `${value.to} <${value.email}>` : value.email
                        return (
                            <div>
                                <Chip label={mail} />
                            </div>
                        )
                    },
                },
                {
                    buttons: [{
                        label: 'std_edit',
                        icon: 'fa fa-pen',
                        className: 'btn btn-default',
                        is_edit_btn: true
                    }],
                    is_editable: true,
                    multiple: true,
                    controlList: membersForm,
                    type: 'substep',
                    name: 'members',
                    label: MEMBERS,
                    value: [],
                    onRenderTemplate: (value) => {
                        return (
                            <UserStudentItem {...value} />
                        )
                    },
                },
                {
                    type: "textarea",
                    name: "comments",
                    label: COMMENTS
                },
            ],
            value: {},
            graphQL: {
                entity: 'userStudentFamily',
                enableFetch: id !== undefined
            },
            next: {
                label: SAVE,
                className: "btn btn-primary text-white",
            },
            back: {
                label: CANCEL,
            },
            fields: {

            },

        },
        onBeforeSaving: (value) => {
            return {
                ...value,
                paymentType: value.paymentType?.join(','),
            }
        },
        id: "invoice-generate-form",
    };
}

const i18n = [
    "std_save",
    "std_cancel",
    "Bsm.Invoice.User.Student.Family.Designation.Label",
    "Bsm.Invoice.User.Student.Family.FatherName.Label",
    "Bsm.Invoice.User.Student.Family.MotherName.Label",
    "Bsm.Invoice.User.Student.Family.PaymentPeriod.Label",
    "Bsm.Invoice.User.Student.Family.PreferedPaymentCurrency.Label",
    "Bsm.Invoice.User.Student.Family.PaymentType.Label",
    "Bsm.Invoice.User.Student.Family.Emails.Label",
    "Bsm.Invoice.User.Student.Family.Comments.Label",
    "Bsm.Invoice.User.Student.Family.Members.Label",
    "Bsm.Invoice.User.Student.Family.Currency.Label",
]